export default __webpack_public_path__ + "static/media/Nakush.6fb0c3fc.jpg";